import PropTypes from 'prop-types';
import { kea } from 'kea';

interface EventClosedDialogActions {
  closeEventClosedDialog: string;
  openEventClosedDialog: string;
}

interface EventClosedDialogReducer {
  actions: EventClosedDialogActions;
}

interface EventClosedDialogPayload {
  eventClosedDialogIsOpen: boolean;
}

export default kea({
  path: () => ['layout', 'eventClosedDialog'],
  actions: () => ({
    closeEventClosedDialog: () => {
      return { eventClosedDialogIsOpen: false };
    },
    openEventClosedDialog: () => {
      return { eventClosedDialogIsOpen: true };
    },
  }),
  reducers: ({ actions }: EventClosedDialogReducer) => ({
    eventClosedDialogIsOpen: [
      false,
      PropTypes.bool,
      {
        [actions.closeEventClosedDialog]: (
          state: boolean,
          payload: EventClosedDialogPayload,
        ) => payload.eventClosedDialogIsOpen,
        [actions.openEventClosedDialog]: (
          state: boolean,
          payload: EventClosedDialogPayload,
        ) => payload.eventClosedDialogIsOpen,
      },
    ],
  }),
});
